
export default {
  props: {
    atend: {type: Boolean, default: false},
    loading: {type: Boolean, default: false}
  },
  methods: {
    getLoader() {
      return this.$refs.loader
    }
  }
}
